export enum RideSearcherMode {
    Ride = "ride",
    Manul = "manual"
}